import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import Select from "common/components/Select/Select";

export type ProcessOptionsType = (options: any[]) => {
  value: string;
  label: string;
}[];

function AnimalReproductiveStatusSelect(props: any) {
  const { t } = useTranslation();

  const options = useMemo(
    () => [
      { label: t("animals.reproductive"), value: "reproductive" },
      { label: t("animals.non_reproductive"), value: "non_reproductive" },
    ],
    [t]
  );

  return <Select options={options} {...props} />;
}

export default AnimalReproductiveStatusSelect;
